module.exports = __webpack_public_path__ + "static/media/roble_nesso.3cd11773.jpg";